import { language } from "./language"

export const getCategoryname = (id: any, listcategories: Array<any>, defaultLanguage: string): any => {
    if(listcategories.length !== 0){
        const categoryName = listcategories.find( field => field.id === parseInt(id))
        
        if(categoryName){
            return categoryName.name
        }

    }else{
        return `${language[defaultLanguage]["consulting"]}...`
    }

}